export { login, checkLogin, logout } from './auth';

export { createAdmin, fetchAdmins, updateAdmin, deleteAdmin, checkEmail } from './admins';

export { fetchUsers } from './user';

export { fetchAppUsers, updateAppUsers } from './appUsers';

export { fetchAllProducts, fetchProducts, updateProduct, fetchProductsByTypes } from './products';

export { updateCart, clearCart, trimCart, sendToQRcode } from './cart';

export { clearQRcode, deleteQRcode, updateQRcode } from './QRcode';

export {
  createPromo,
  fetchPromo,
  fetchPromos,
  deletePromoduct,
  patchPromo,
  deletePromo,
  notifyPromo,
  updateHighlightedPromos,
} from './promos';

export { fetchList, downloadList } from './lists';

export { fetchRooms, addRooms, addRoomAsync, updateRoom, deleteRoom, deleteRoomAsync } from './rooms';

export { fetchProductTypes } from './product_types';

export { fetchInventoryUploads } from './inventory';



// WEBPACK FOOTER //
// ./src/store/actions/index.js